import type { SurveyFilters } from "../../types/defaultTypes";
import { apiClient } from "../clientApi";
import type { AxiosResponse } from "axios";

export const getSurveyFilters = async () => {
  const { data } = await apiClient.get<SurveyFilters, AxiosResponse<SurveyFilters>>(`/surveys/survey-filters`);

  return data as SurveyFilters;
};
